import type { PageContext, SuggestionBubble } from '@/features/ai/types'

/**
 * Suggestion bubbles surfaced in the AIR® AI empty state on /search.
 *
 * Function form (not a static array) so future iterations can read the live
 * `PageContext` and tailor labels/prompts to the current query, integrations,
 * or time range. v1 returns a static list since `search_overview` PageContext
 * is not yet emitted by the backend (research/backend-noah.md §3).
 *
 * All bubbles carry `requires: 'search'` so `<AIEmptyState>` filters them out
 * for users without the SearchLogs gate (Analyst role + `is_search_enabled`).
 *
 * Two OPENERS only. "Narrow this to admin users" and "Summarize these results"
 * are deliberately absent: they are follow-ups to the first bubble, not chips.
 * Clicked cold as a first message they are meaningless — there is nothing yet
 * to narrow or summarize — so the demo serves them as the second turn of that
 * conversation instead (`__mocks__/world/data/noah.ts`).
 */
export const getSearchBubbles = (
	_ctx: PageContext,
): Array<SuggestionBubble> => [
	{
		id: 'search.failed-logins-24h',
		label: 'Show failed logins last 24h',
		prompt:
			'Show me all failed login attempts across all integrations in the last 24 hours. Group by user and source IP.',
		requires: 'search',
	},
	{
		id: 'search.unfamiliar-locations',
		label: 'Admin sign-ins from new locations',
		prompt:
			'Show successful sign-ins from locations this tenant has not seen before. Highlight privileged accounts.',
		requires: 'search',
	},
]
